export function scapeQueryParams(queryParams: string): string {
  if (queryParams) {
    const params = new URLSearchParams(queryParams);
    const paramsScaped = {};

    for (const [param, value] of params) {
      paramsScaped[param] = encodeURIComponent(value);
    }
    const scapedQueryString = new URLSearchParams(paramsScaped).toString();

    return `?${scapedQueryString}`;
  }

  return "";
}
